import { RpExecution } from "@/api/reportPortal/client"

export interface AccountPassRate {
  pct: number
  passed: number
  counted: number
}

// Rate = PASSED / (PASSED + FAILED) across every execution list; SKIPPED,
// INTERRUPTED and anything else is neither a pass nor a failure.
export const computeAccountPassRate = (
  executionLists: RpExecution[][],
): AccountPassRate | null => {
  const counted = executionLists
    .flat()
    .map((execution) => execution.status)
    .filter((status) => status === "PASSED" || status === "FAILED")
  if (counted.length === 0) return null
  const passed = counted.filter((status) => status === "PASSED").length
  return {
    pct: Math.round((100 * passed) / counted.length),
    passed,
    counted: counted.length,
  }
}
